interface ViraLensLogoProps {
  height?: number;
}

export function ViraLensLogo({ height = 32 }: ViraLensLogoProps) {
  return (
    <img
      src={`${import.meta.env.BASE_URL}viralens-logo.png`}
      alt="ViraLens"
      style={{ height, width: "auto" }}
      draggable={false}
    />
  );
}
